module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr-ca":{"Quick Links":"Accès rapide"}}')
  delete Component.options._Ctor
}
